import type * as React from 'react';

function SvgAge(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M22 12c0 5.522-4.477 10-10 10S2 17.522 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10" fill="#1ED560" />
        <path
          d="M8.13 15.24v-.88H5.4l1.27-1.62c.78-1 .78-1 1.02-1.43.28-.49.41-.96.41-1.47C8.1 8.66 7.4 8 6.15 8c-1.26 0-2.01.65-2.1 1.83l.98.08c.13-.68.5-1.03 1.08-1.03.61 0 .93.32.93.92 0 .61-.33 1.31-1.06 2.23L4 14.54v.7h4.13zm4.28 0V8.1h-.72l-1.87.8.33.82 1.19-.51v6.03h1.07zm5.26-1.28v-1.91h1.87v-.82h-1.87V9.31h-.89v1.92h-1.87v.82h1.87v1.91h.89z"
          fill="#00182E"
        />
      </g>
    </svg>
  );
}

export default SvgAge;
